module.exports = __webpack_public_path__ + "img/galet_marbre_blanc_rose.9eb87e33.jpg";